// Firebase configuration
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCUAO8Qt6Cl5um7F8WiqEXZ4ee3yLQ2Xak",
  authDomain: "getcall-637a5.firebaseapp.com",
  projectId: "getcall-637a5",
  storageBucket: "getcall-637a5.firebasestorage.app",
  messagingSenderId: "237253721845",
  appId: "1:237253721845:web:ca874919441f714cf28fbc",
  measurementId: "G-PPBJFGQFXZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, app, db };
export default app;